import { object, boolean, string } from 'yup';

export function makeMeetingSchema() {
  return object().shape({
    a: boolean(),
    b: boolean(),
    note: string(),
  });
}
